import React, { useEffect, useRef, useState } from 'react';
import '../Assets/Css/TableRow.scss';
import UserAvatar from 'react-user-avatar';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light.css';
import { FiArrowDownLeft, FiArrowUpLeft, FiEye } from 'react-icons/fi';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../Lib/Init-firebase';
import { BiEditAlt } from 'react-icons/bi';
import { TiDelete } from 'react-icons/ti';
import queryString from 'query-string';
import RoleWiseFeatureWrapper from '../Lib/RoleWiseFeatureWrapper';
import dots from '../Assets/Images/Employee/✳️ secondary action.svg';
import Swal from 'sweetalert2';
import Select from 'react-select';
import Map from '../Assets/Images/Attendance/map-person.svg';
import ProgressBar from 'react-bootstrap/ProgressBar';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { BsPauseCircleFill, BsStopCircleFill } from "react-icons/bs";
import { FaClock, FaHourglass, FaStopCircle, FaUserCircle } from "react-icons/fa";
import { FaCirclePlay } from "react-icons/fa6";
import { HiPlus } from "react-icons/hi";
import { MdOutlineWatchLater } from "react-icons/md";
import PDFIcon from '../Assets/Images/Employee/PDF Icon.svg'
import JPGIcon from '../Assets/Images/Employee/JPG Icon.svg'
import PNGIcon from '../Assets/Images/Employee/PNG Icon.svg'
import OpenEye from '../Assets/Images/Employee/OpenEye.svg'
import CloseEye from '../Assets/Images/Employee/CloseEye.svg'
import RightUpArrow from '../Assets/Images/Employee/Right-Up Arrow.svg'
import { connect } from 'react-redux';
import { toast } from 'react-toastify';

import Pdf from '../Assets/Images/Employee/Pdf.svg'
import Jpg from '../Assets/Images/Employee/Jpg.svg'
import Png from '../Assets/Images/Employee/Png.svg'
import Image from '../Assets/Images/Employee/Image.png'
import { getAuthHeader, getIconComponent } from '../Lib/utils';
import { IoWarning } from 'react-icons/io5';
import useTimerStore from '../Lib/timerStore';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import AttendancebyHour from '../Assets/Images/Attendance/AttendancebyHour';
import { api } from '../Lib/constants';
import { Spinner } from 'react-bootstrap';
import { CiCircleMinus, CiCirclePlus } from "react-icons/ci";
import { editWaterJugs, getWaterJugs } from '../Services/WaterJug/action';
import { store } from '../Services/store';

const initialState = {
  projectstatus: { value: 'Incomplete', label: 'Incomplete', color: '#D21010' },
}

const ProjectStatus = [
  { value: 'Incomplete', label: 'Incomplete', color: '#D21010' },
  { value: 'To-Do', label: 'To Do', color: '#F5C308' },
  { value: 'Doing', label: 'Doing', color: '#00B5FF' },
  { value: 'Completed', label: 'Completed', color: '#679C0D' },
  { value: 'Approved', label: 'Approved', color: '#212529' },
];

const TicketStatus = [
  { value: 'Open', label: 'Open', color: 'red' },
  { value: 'Pending', label: 'Pending', color: 'yellow' },
  { value: 'Resolved', label: 'Resolved', color: 'green' },
  { value: 'Closed', label: 'Closed', color: 'blue' },
]

const AwardStatus = [
  { value: 'Active', label: 'Active', color: '#679C0D' },
  { value: 'Inactive', label: 'Inactive', color: '#212529' },
];

const customStyle = {
  control: (provided) => ({
    ...provided,
    minHeight: '40px',
    width: '155px',
  }),
  option: (provided, { isFocused }) => ({
    ...provided,
    backgroundColor: isFocused ? '#5757fe' : '#fff',
    color: isFocused ? '#fff' : '#000',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    height: '40px',
  }),
  menu: (provided) => ({
    ...provided,
    width: '150px',
  }),
};

const TableRow = ({ key, data, index, header, setModelData, setShow, selectedId, checked, handleChange, totalSelectedIds, idsArray, showIsView,
  features, modules, user, ModuleNameForEdit, Featur_NameForEedit, ModuleNameForView, Featur_NameForView, ModuleNameForDelete, Featur_NameForDelete,
  showIsApprove, showIsDelete, showIsReject, showIsCancel, showIsDownload, isDownloadSalarySlip, showIsProgressChart, showIsTimesheet, showIsEdit, showIsReply, setFields, IsStopTimer,
  TaskApprove, updateTask, deleteRecord, updateLeave, updateAward, updateTicket, TaskStatus, onRowClick, rowClickType = "modal" }) => {

  let statusQuery = queryString.parse(location.search).status;
  const { start, pause, resume, stop, updateTimer: update } = useTimerStore();
  const [isOpen, setIsOpen] = useState(false);
  const [visibility, setVisibility] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const { employeeId } = useParams();

  const updateTimer = async (status) => {
    try {
      const assignedUsers = data?.['Assigned To']?.value || [];
      const isHR = data?.user?.role?.name === "hr_senior";
      const isEmployeeView = assignedUsers?.some(user => user?.isEmployeeTaskPage === true);
      const localUserId = parseInt(employeeId, 10);

      let employeeIds = [];

      if (isHR) {
        const assignedIds = assignedUsers.map(user => user?.id);

        if (isEmployeeView) {
          if (assignedIds.includes(localUserId)) {
            employeeIds = [localUserId];
          } else {
            employeeIds = assignedIds.filter(id => id !== data?.user?.id);
          }
        }
        else {
          if (assignedIds.includes(data?.user?.id)) {
            employeeIds = [data?.user?.id];
          } else {
            employeeIds = assignedIds;
          }
        }
      } else {
        employeeIds = [user?.id];
      }

      if (status === "playClicked") {
        if (data?.timerIsRunning?.value) {
          toast.error("Timer is already running for a task.")
          return;
        }
        else {
          const start_time = new Date();
          await Promise.all(
            employeeIds.map((empId, index) => {
              updateTask(data?.checkbox?.value2, { start_time, employee_id: empId, task_id: data?.checkbox?.value }, index === 0 ? true : false)
              start(empId, data?.checkbox?.value);
              update(empId, data?.checkbox?.value);
            })
          )
        }
      }
      else if (status === "pauseClicked") {
        const pause_time = new Date();
        await Promise.all(
          employeeIds.map(empId => {
            updateTask(data?.checkbox?.value2, { pause_time, employee_id: empId, task_id: data?.checkbox?.value }, true)
            pause(empId, data?.checkbox?.value);
            update(empId, data?.checkbox?.value);
          }))
      }
      else if (status === "resumeClicked") {
        const resume_time = new Date();
        await Promise.all(
          employeeIds.map(empId => {
            updateTask(data?.checkbox?.value2, { resume_time, employee_id: empId, task_id: data?.checkbox?.value }, true)
            resume(empId, data?.checkbox?.value);
            update(empId, data?.checkbox?.value);
          }
          ))
      }
      else {
        await Promise.all(
          employeeIds.map(empId => {
            stop(updateTask, empId, data?.checkbox?.value2, data?.checkbox?.value)
            update(empId, data?.checkbox?.value);
          }
          ))
      }
    } catch (error) {
      console.error("Error updating task timers in table in task page:", error)
    }
  };

  const amountVisibility = (field) => {
    setVisibility((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };

  const dropdownRef = useRef(null);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  const handleClick = () => {
    if (!data.id) {
      return null;
    }
    setModelData({
      name: data.Name.value,
      email: data.Email.value,
      phoneNumber: data['Phone Number'].value,
      subject: data.Subject.value,
      description: data.description.value,
    });
    setShow(true);
    const docRef = doc(db, 'users', data.id.value);
    updateDoc(docRef, { read: true })
      .then((response) => { })
      .catch((error) => { });
  };
  const handleRowClick = (event) => {
     if (event.target.closest('.taskstartstop-icons') || 
        event.target.closest('.actions') || 
        event.target.closest('.dropdown') ||
        event.target.closest('.icon-container')) {
        event.stopPropagation();
        return;
    }
    if (rowClickType === "navigate" && onRowClick) {
      onRowClick(data);
    } else {
      handleClick();
    }
  };
  const isRedRow = data?.Description?.value === '' || data?.allPaymentDistributed === false;
  const shouldShowRow = () => {
    if (statusQuery === 'Unassigned') {
      return isRedRow;
    } else if (statusQuery === 'Assigned') {
      return !isRedRow;
    } else {
      return true;
    }
  };

  const [clientData, setClientData] = useState({
    title: null,
    statusoption: null,
  });

  if (!shouldShowRow()) {
    return null;
  }

  const handleDelete = async (deleteValue) => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    }).then(async (result) => {
      if (result.isConfirmed) {
        await deleteRecord(data?.checkbox?.value || deleteValue, location?.pathname);
        Swal.fire('Deleted!', 'Your item has been deleted.', 'success')
      }
    });
  };

  const handleDownload = (e, url, fileName) => {
    e.preventDefault();

    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  const handleLeaveStatusUpdate = async (value) => {
    const statusMap = {
      Approve: 'Approved',
      Reject: 'Rejected',
    };

    try {
      console.log(data, "DATA")
      const leaveIds = data?.checkbox?.value;
      const status = statusMap[value] || value;
      const previousStatus = data?.['Leave Status']?.value;
      if (leaveIds?.length > 0) {
        await updateLeave(leaveIds, { status, previous_status: previousStatus });
      } else {
        await updateLeave([data?.checkbox?.value], { status, previous_status: previousStatus });
      }

    } catch (error) {
      console.error("Error in updating status in leave:", error);
    }
  }

  const handleStopTimer = async () => {
    try {
      const empId = location.pathname?.includes('/employees') ? parseInt(employeeId, 10) : user?.id;
      const task_id = data?.allData?.task_id;
      await stop(updateTask, empId, data?.checkbox?.value2, task_id)
      await update(empId, task_id);
    } catch (error) {
      console.error("Error in updating timer in timesheet:", error)
    }
  }

  const handleDownloadSalarySlip = async (params) => {
    setIsLoading(true);
    try {
      const result = await api(
        `salary/download/salarySlip`,
        'post',
        { data: data?.allData },
        getAuthHeader(),
        { responseType: 'blob' }
      );
      const blob = new Blob([result.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      window.open(url);
      await new Promise((resolve) => setTimeout(resolve, 500));
    } catch (error) {
      console.error('Error downloading salary slip:', error);
      toast.error('Failed to download salary slip.');
    } finally {
      setIsLoading(false);
    }
  };
  const navigate = useNavigate();
  const handleEmployeeClick = (employeeData) => {
    if (employeeData?.clickPath) {
      navigate(employeeData.clickPath);
    }
  };

  const handleIncrement = async (item) => {
    try {
      const updatedValue = (Number(item.no_of_jug) || 1) + 1;
      await store.dispatch(editWaterJugs(item.id, { ...item, no_of_jug: updatedValue }));
      await store.dispatch(getWaterJugs());
    } catch (error) {
      console.error('Error updating water jug count:', error);
    }
  };

  const handleDecrement = async (item) => {
    try {
      if (item.no_of_jug > 1) {
        const updatedValue = Number(item.no_of_jug) - 1;
        await store.dispatch(editWaterJugs(item.id, { ...item, no_of_jug: updatedValue }));
        await store.dispatch(getWaterJugs());
      }
    } catch (error) {
      console.error('Error updating water jug count:', error);
    }
  };

  return (
    <tr className={`table-data-row ${isRedRow ? 'bg-red' : ''}`} key={data?.checkbox?.value} onClick={handleRowClick}>
      {isLoading && (
        <div
          className="loading-overlay"
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: '#969696',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 10000,
            backdropFilter: 'blur(5px)',
          }}
        >
          <Spinner as="span" animation="border" role="status" aria-hidden="true" />
        </div>
      )}
      {header.map((col, index) => {
        if (data[col.field]) {
          switch (data[col.field].type) {
            case 'checkbox':
              const currentRowId = data?.invoiceId?.value || data?.checkbox?.value || data?.Code;
              return (
                <td className="table-data-td" key={index}>
                  <input
                    type="checkbox"
                    checked={(totalSelectedIds || []).includes(currentRowId)}
                    onChange={(e) => {
                      handleChange({
                        type: "select-one",
                        checked: e.target.checked,
                        id: currentRowId,
                      });
                    }}
                  />
                </td>
              );
            case 'total':
              return (
                <td className="table-data-td" key={index}>
                  <h6 className="total">{data[col.field].value}</h6>
                </td>
              );
            case 'text':
              return (
                <td className={`table-data-td ${data['Mobile']?.isNavigate ? " emp-td" : ""} `} key={index}>
                  {(() => {
                    const content = data[col.field].late_value ?
                      <h6 className="text task-title" style={{ color: 'rgba(190, 0, 3, 1)' }}>{data[col.field].late_value}</h6> :
                      (data[col.field].value2 ? (
                        <div className="client">
                          <div className="client-data">
                            <h6 className="highlight-text">{data[col.field].value}</h6>
                            <h6 className="small-text">{data[col.field].value2}</h6>
                          </div>
                        </div>
                      ) :
                        (data[col.field]?.value == "Active") ? (
                          <>
                            <div style={{
                              backgroundColor: '#1d82f5',
                              color: '#fff',
                              borderRadius: '.25rem',
                              display: 'inline-block',
                              fontSize: '75%',
                              fontWeight: 700,
                              lineHeight: 1,
                              padding: '.25em .4em',
                              textAlign: 'center',
                              transition: 'color .15s ease-in-out',
                              borderColor: '.15s ease-in-out',
                              boxShadow: '.15s ease-in-out',
                              verticalAlign: 'baseline',
                              whiteSpace: 'nowrap',

                            }}><FaClock />{' '}{data[col.field].value}</div>
                          </>
                        ) :
                          (
                            <h6 className="text">{data[col.field].value}</h6>
                          )
                      )
                    return data['Mobile']?.isNavigate ? (
                      <Link className="td-link" to={data['Action'].value2} style={{ textDecoration: "inherit", color: "inherit" }} state={{ data: data, from: location.pathname }}>{content}</Link>
                    ) : (
                      <div>{content}</div>
                    );
                  })()}
                </td>
              );
            case 'end_time':
              return (
                <td className="table-data-td" key={index}>
                  {(() => {
                    const rowData = data[col.field];
                    const endDate = rowData?.end_date;
                    const startDate = rowData?.start_date;
                    const endTime = rowData?.end_time;

                    if (endDate != "null" && endTime != "null") {
                      return (
                        <div className="client">
                          <div className="client-data">
                            <h6 className="text">
                              {endDate.split(' ')[0]} {endTime}
                            </h6>
                          </div>
                        </div>
                      );
                    } else if (endDate == "null" && endTime != "null") {
                      return (
                        <div className="client">
                          <div className="client-data">
                            <h6 className="text">
                              {startDate?.split(' ')[0]} {endTime}
                            </h6>
                          </div>
                        </div>
                      );
                    } else {
                      return (
                        <div className="client">
                          <div className="client-data">
                            <h6 className="text"
                              style={{
                                backgroundColor: "#1d82f5",
                                color: 'white',
                                borderRadius: '4px',
                                padding: '5px',
                                fontSize: '12px'
                              }}>
                              <AttendancebyHour color="white" /> Active
                            </h6>
                          </div>
                        </div>
                      );
                    }
                  })()}
                </td>

              )
            case 'emptext':
              return (
                <td className="table-data-td" key={index}>
                  <h6 className="emptext">{data[col.field].value}</h6>
                </td>
              );
            case 'amount':
              return (
                <td className={`table-data-td ${data['Salary']?.isNavigate ? " emp-td" : ""}`} key={index}>
                  {(() => {
                    const content = (<h6 className="amount">{data[col.field].value}</h6>)
                    return data['Salary']?.isNavigate ? (
                      <Link className="td-link" to={data['Action'].value2} style={{ textDecoration: "inherit", color: "inherit" }} state={{ data: data, from: location.pathname }}>{content}</Link>
                    ) : (
                      <div>{content}</div>
                    );
                  })()}
                </td>
              );
            case 'percentages':
              return (
                <td className="table-data-td" key={index}>
                  <h6 className="date">{data[col.field].value}</h6>
                </td>
              );
            case 'client':
              return (
                <td className={`table-data-td ${data['Employee']?.isNavigate ? " emp-td" : ""}`} key={index}>
                  {(() => {
                    const content = (
                      <>
                        <div className="client">
                          <div className="client-image">
                            {data[col.field]?.src ? (
                              <img
                                width={40}
                                height={40}
                                src={`data:image/jpeg;base64,${btoa(
                                  new Uint8Array(data[col.field]?.src).reduce(
                                    (data, byte) => data + String.fromCharCode(byte),
                                    ''
                                  )
                                )}`}
                                alt={data[col.field]?.value}
                              />
                            ) : (
                              <UserAvatar
                                name={data[col.field]?.value || "CD"}
                                size={100}
                                style={{ textTransform: 'uppercase', color: 'white' }}
                                color="#5757fe"
                              />
                            )}
                          </div>
                          <div className="client-data">
                            {data[col.field]?.isClickable ? (
                              <span
                                onClick={() => handleEmployeeClick(data[col.field])}
                                style={{ cursor: 'pointer' }}
                              >
                                {data[col.field]?.value}
                              </span>
                            ) : (
                              <span>{data[col.field]?.value}</span>
                            )}
                            <div style={{ display: 'flex', justifyContent: 'flex-start', gap: '10%' }}>
                              <h6 className="small-text">{data[col.field]?.value2}</h6>
                              {data[col.field]?.value3 && <h6 className="its-you">{data[col.field]?.value3}</h6>}
                            </div>
                          </div>
                        </div>
                        <div>
                          <h6>{data[col.field].title || ""}</h6>
                        </div>
                      </>
                    );
                    return data['Employee']?.isNavigate ? (
                      <Link className="td-link" to={data['Action'].value2} style={{ textDecoration: "inherit", color: "inherit" }} state={{ data: data, from: location.pathname }}>{content}</Link>
                    ) : (
                      <div>{content}</div>
                    );
                  })()}
                </td>
              );
            case 'date':
              return (
                <td className="table-data-td" key={index}>
                  <h6 className="date">{data[col.field].value}</h6>
                  {data[col.field].value2 ? <h6 className="text">{data[col.field].value2}</h6> : ''}
                </td>
              );
            case 'empdate':
              return (
                <td className="table-data-td" key={index}>
                  <h6 className="empdate">{data[col.field].value}</h6>
                  {data[col.field].value2 ? <h6 className="emptext">{data[col.field].value2}</h6> : ''}
                </td>
              );
            case 'image':
              return (
                <td className="table-data-td" style={data[col.field].value2 ? { justifyContent: "space-between", display: 'flex' } : {}} key={index}>
                  <img className="table-image" style={{ width: data[col.field].width, height: data[col.field].height }} src={data[col.field].value} />
                  {data[col.field].value2 && (
                    <img className="table-image" style={{ width: data[col.field].width, height: data[col.field].height }} src={data[col.field].value2} />
                  )}
                </td>
              );
            case 'share holder':
              if (data[col.field]?.value !== undefined) {
                return (
                  <td className="table-data-td" key={index}>
                    <div className="share-holder">
                      {data[col.field]?.value?.slice(0, 3)?.map((sh, index) => {
                        return (
                          <div key={index}>
                            {sh?.src ? (
                              <div className="sh-img" key={index}>
                                <UserAvatar
                                  size="40"
                                  name={sh?.name || "Unknown"}
                                  src={sh?.src}
                                />
                                <div className="tooltip">{sh?.name || "Unknown"}</div>
                              </div>
                            ) : (
                              <div className='sh-avatar'>
                                <UserAvatar
                                  name={sh?.name || "Unknown"}
                                  size={40}
                                  color="#5757fe"
                                  style={{ textTransform: 'uppercase', color: 'white' }}
                                />
                                <div className="tooltip">{sh?.name || "Unknown"}</div>
                              </div>
                            )}
                          </div>

                        );
                      })}
                      {data[col.field]?.value?.length >= 4 ? (
                        <div className="sh-img">{`+${data[col.field]?.value?.length - 3}`}</div>
                      ) : null}
                    </div>
                  </td>
                );
              } else {
                return <td className="table-data-td" key={index}></td>;
              }
            case 'status':
              return (
                <td className="table-data-td" key={index}>
                  <div className="status">
                    <div className={`status-circle ${data[col.field]?.value?.split(" ")?.join("")?.toLowerCase()}`}></div>
                    <h6 className={`status-text ${data[col.field]?.value?.split(" ")?.join("")?.toLowerCase()}`}>
                      {data[col.field]?.value}
                    </h6>
                  </div>
                </td>
              );
            case 'attandancestatus':
              return (
                <td className="table-data-td" key={index}>
                  {data[col.field]?.value2 && (
                    <div className={`status ${data[col.field]?.value2?.split(" ").join('')}`}>
                      <div>
                        <h6 className={`status-text`}>{data[col.field]?.value2}</h6>
                      </div>
                    </div>
                  )}
                  {data[col.field]?.value && (
                    <div className={`status ${data[col.field]?.value?.split(" ").join('')}`}>
                      <h6 className={`status-text`}>{data[col.field]?.value}</h6>
                    </div>
                  )}
                </td>
              );
            case 'clockin':
              return <td className="table-data-td" key={index}>
                <div className="clockin">
                  {data[col.field]?.value.map((item) => (
                    <div className='clockin_comp'>
                      <h6 className='clockintime'>{item.clockIn}</h6>
                      {item?.lateValue && <h6><IoWarning />{item?.lateValue}</h6>}
                      <img src={Map} />
                      <h6>{`${item.location}`}</h6>
                    </div>
                  ))}
                </div>
              </td>
            case 'clockout':
              return (
                <td className="table-data-td" key={index}>
                  <div className="clockin">
                    {data[col.field]?.value.map((item) => (
                      <>
                        <div className="clockin_comp">
                          <h6 className="text">{item.clockOut}</h6>
                        </div>
                      </>
                    ))}
                  </div>
                </td>
              );
            case 'credit':
              return (
                <td className="table-data-td" key={index}>
                  <div className="credit">
                    <div className="credit-icon">
                      <FiArrowUpLeft />
                    </div>
                    <p className="credit-name">{data[col.field]?.value}</p>
                  </div>
                </td>
              );
            case 'debit':
              return (
                <td className="table-data-td" key={index}>
                  <div className="debit">
                    <div className="debit-icon">
                      <FiArrowDownLeft />
                    </div>
                    <p className="debit-name">{data[col.field].value}</p>
                  </div>
                </td>
              );
            case 'description':
              return (
                <td className="table-data-td" key={index}>
                  <h6 className="description">{data[col.field]?.value}</h6>
                </td>
              );
            case 'Rate':
              return (
                <td className="table-data-td" key={index}>
                  <h6 className="description">{data[col.field]?.value}</h6>
                </td>
              );
            case 'qty':
              return (
                <td className="table-data-td" key={index}>
                  <h6 className="description">{data[col.field]?.value}</h6>
                </td>
              );
            case 'invoices':
              return (
                <td className="table-data-td" key={index}>
                  <Tippy
                    theme={'light'}
                    content={
                      <ul style={{ listStyleType: 'none' }}>
                        {data[col.field]?.value?.map((invoice, index) => {
                          return <li key={index}>{invoice.id}</li>;
                        })}
                      </ul>
                    }
                  >
                    <h6 className="invoices">
                      {data[col.field].value.map((no) => {
                        return no.id;
                      })}
                    </h6>
                  </Tippy>
                </td>
              );
            case 'action':
              return (
                <td className="table-data-td" key={index}>
                  <div className="actions">
                    {/* {features?.length > 0 || features != undefined ?
                    <RoleWiseFeatureWrapper modules={modules} features={features} user={user} ModuleName={ModuleNameForEdit} Featur_Name={Featur_NameForEedit}>
                      <Link to={data[col.field].value} style={{ textDecoration: "inherit", color: "inherit" }} state={{ data: data }}><BiEditAlt /></Link>
                    </RoleWiseFeatureWrapper>
                    :
                    <Link to={data[col.field].value} style={{ textDecoration: "inherit", color: "inherit" }} state={{ data: data }}><BiEditAlt /></Link>
                  }
                  {features?.length > 0 || features != undefined ?
                    <RoleWiseFeatureWrapper modules={modules} features={features} user={user} ModuleName={ModuleNameForView} Featur_Name={Featur_NameForView}>
                      {showIsView && <Link to={data[col.field].value2} style={{ textDecoration: "inherit", color: "inherit" }} state={{ data: data }}><FiEye /></Link>}
                    </RoleWiseFeatureWrapper>
                    :
                    (
                      showIsView && (<Link to={data[col.field].value2} style={{ textDecoration: "inherit", color: "inherit" }} state={{ data: data }}><FiEye /></Link>)
                    )
                  } */}

                    <div className={`dropdown ${isOpen ? 'dropdown--active' : ''}`} ref={dropdownRef}>
                      <button className="dropdown__button" onClick={toggleDropdown}>
                        <img src={dots} alt="more options" className="more-icon" />
                      </button>
                      <div className="dropdown__content">
                        {showIsView
                          ? <Link className='dropdown-item' to={data[col.field].value2} style={{ textDecoration: "inherit", color: "inherit" }} state={{ data: data, from: location.pathname }}>View</Link> : null}
                        {showIsReply
                          ? <Link className='dropdown-item' to={data[col.field].value8} style={{ textDecoration: "inherit", color: "inherit" }} state={{ data: data }}>Reply</Link> : null}
                        {(data[col?.field]?.showIsEdit || showIsEdit)
                          ? <Link className='dropdown-item' to={data[col.field].value} style={{ textDecoration: "inherit", color: "inherit" }} state={{ data: data }}>Edit</Link> : null}
                        {showIsDownload
                          ? <Link className='dropdown-item'
                            // to={data[col.field].value1}
                            to="#"
                            // target='_blank'
                            onClick={(e) => {
                              handleDownload(
                                e,
                                data[col.field].value1,
                                data[col.field].fileName
                              )
                            }
                            }
                            //  download
                            style={{ textDecoration: "inherit", color: "inherit" }} state={{ data: data }}>Download</Link> : null}
                        {isDownloadSalarySlip
                          ? <Link className='dropdown-item' onClick={handleDownloadSalarySlip} download style={{ textDecoration: "inherit", color: "inherit" }} state={{ data: data }}>Download</Link> : null}
                        {showIsProgressChart
                          ? <Link className='dropdown-item' to={data[col.field].value7} style={{ textDecoration: "inherit", color: "inherit" }} state={{ data: data }}>Chart</Link> : null}
                        {(data[col?.field]?.showIsApprove || showIsApprove)
                          ? <Link className='dropdown-item' onClick={(e) => {
                            e.preventDefault();
                            handleLeaveStatusUpdate(data[col.field].value4)
                          }} to='#' style={{ textDecoration: "inherit", color: "inherit" }} state={{ data: data }}>Approve</Link> : null}
                        {(data[col?.field]?.showIsReject || showIsReject)
                          ? <Link className='dropdown-item' onClick={(e) => {
                            e.preventDefault();
                            handleLeaveStatusUpdate(data[col.field].value5)
                          }} to='#' style={{ textDecoration: "inherit", color: "inherit" }} state={{ data: data }}>Reject</Link> : null}
                        {(data[col?.field]?.showIsCancel || showIsCancel)
                          ? <Link className='dropdown-item' onClick={(e) => {
                            e.preventDefault();
                            handleLeaveStatusUpdate(data[col.field].value5)
                          }} to='#' style={{ textDecoration: "inherit", color: "inherit" }} state={{ data: data }}>Cancel</Link> : null}
                        {showIsTimesheet
                          ? <Link className='dropdown-item' to={data[col.field].value6} style={{ textDecoration: "inherit", color: "inherit" }} state={{ data: data }}>Timesheet</Link> : null}
                        {data[col.field]?.IsStopTimer
                          ? <Link className='dropdown-item' onClick={(e) => {
                            e.preventDefault();
                            handleStopTimer();
                          }} to={data[col.field].value9} style={{ textDecoration: "inherit", color: "inherit" }} state={{ data: data }}>Stop</Link> : null}
                        {TaskApprove
                          ? <Link className='dropdown-item' to={data[col.field].value9} style={{ textDecoration: "inherit", color: "inherit" }} state={{ data: data }}>Approve</Link> : null}
                        {(data[col?.field]?.showIsDelete || showIsDelete)
                          ? <Link className='dropdown-item' onClick={() => handleDelete(data[col.field].value3)} style={{ textDecoration: "inherit", color: "inherit" }}>Delete</Link> : null}
                      </div>
                    </div>
                  </div>
                </td>
              );

            // case 'action2':
            //   return (
            //     <td className="table-data-td" key={index}>
            //       <div className="actions">
            //         <div className={`dropdown ${isOpen ? 'dropdown--active' : ''}`} ref={dropdownRef}>
            //           <button className="dropdown__button" onClick={toggleDropdown}>
            //             <img src={dots} alt="more options" className="more-icon" />
            //           </button>
            //           <div className="dropdown__content">
            //             {showIsView ? <Link className='dropdown-item' to={data[col.field].value2} style={{ textDecoration: "inherit", color: "inherit" }} state={{ data: data }}>View</Link> : null}
            //             {showIsEdit ? (
            //               <span
            //                 className="dropdown-item"
            //                 style={{ textDecoration: "inherit", color: "inherit", cursor: "pointer" }}
            //                 onClick={(e) => {
            //                   e.preventDefault();
            //                   openModal();
            //                 }}
            //               >
            //                 Edit
            //               </span>
            //             ) : null}
            //           </div>
            //         </div>
            //       </div>
            //     </td>
            //   );

            case 'address':
              return (
                <td className={`table-data-td address-td ${data['Address']?.isNavigate ? "emp-td" : ""}`} key={index}>
                  {(() => {
                    const content = (
                      <div className="address">
                        <p>
                          {[data[col.field].value, data[col.field].country]
                            .filter(Boolean)
                            .join(', ')}
                        </p>
                      </div>
                    )
                    return data['Address']?.isNavigate ? (
                      <Link className="td-link" to={data['Action'].value2} style={{ textDecoration: "inherit", color: "inherit" }} state={{ data: data, from: location.pathname }}>{content}</Link>
                    ) : (
                      <div>{content}</div>
                    );
                  })()}
                </td>
              );
            case 'delete':
              return (
                <td className="table-data-td" key={index}>
                  <div className="delete-action">
                    {features?.length > 0 || features != undefined ? (
                      <RoleWiseFeatureWrapper
                        modules={modules}
                        features={features}
                        user={user}
                        ModuleName={ModuleNameForDelete}
                        Featur_Name={Featur_NameForDelete}
                      >
                        <button className="delete-btn">
                          <TiDelete />
                        </button>
                      </RoleWiseFeatureWrapper>
                    ) : (
                      <button className="delete-btn">
                        <TiDelete />
                      </button>
                    )}
                  </div>
                </td>
              );

            case 'leaveType':
              return (
                <td className="table-data-td" key={index}>
                  <div className="leaveType">
                    <div className={`leaveType-background`}>
                      <h6 className={`leaveType-text`}>{data[col.field]?.value}</h6>
                    </div>
                    {data[col.field].value2 && (<div>{data[col.field].value2}</div>)}
                  </div>
                </td>
              );

            case 'leaveStatus':
              const leaveStatus = data[col.field]?.value;
              let statusColor;

              if (leaveStatus === 'Approved') {
                statusColor = 'rgb(0, 194, 146)';
              } else if (leaveStatus === 'Pending') {
                statusColor = '#f6b000';
              } else if (leaveStatus === 'Rejected') {
                statusColor = '#D21010';
              }

              return (
                <td className="table-data-td" key={index}>
                  <div className="leaveStatus">
                    <div
                      className={`leaveStatus-circle ${leaveStatus}`}
                      style={{ backgroundColor: statusColor }}
                    ></div>
                    <h6
                      className={`leaveStatus-text ${leaveStatus}`}
                      style={{ color: statusColor }}
                    >
                      {leaveStatus}
                    </h6>
                  </div>
                </td>
              );


            case 'images':
              return (
                <td className="table-data-td" key={index}>
                  <div className="client">
                    <div>
                      <img src={data[col.field]?.image} alt="Image" className="image-cell" />
                    </div>
                    <div className="client-data">
                      <h6 className="highlight-text">{data[col.field].value}</h6>
                      <h6 className="small-text">{data[col.field].value2}</h6>
                    </div>
                  </div>
                </td>
              );

            case 'award':
              const Icon = getIconComponent(data[col.field]?.icon)
              return (
                <td className="table-data-td" key={index}>
                  <div className="client">
                    <div
                      className="image-cell"
                      style={{
                        backgroundColor: data[col.field]?.value2 || '#eee',
                        width: 40,
                        height: 40,
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#fff',
                        fontSize: 20,
                      }}
                    >
                      {Icon && <Icon />}
                    </div>
                    <div className="client-data">
                      <h6 className="highlight-text">{data[col.field].value}</h6>
                    </div>
                  </div>
                </td>
              );
            case 'image_round':
              return (
                <td className="table-data-td" key={index}>
                  <div className="client">
                    <div className="client-image">
                      {data[col.field]?.image ? (
                        <img src={data[col.field]?.image} alt="Image" className="image-cell" />
                      ) : (
                        <FaUserCircle size={40} color="rgb(180, 180, 180)" />
                      )}
                    </div>
                    <div className="client-data">
                      <h6 className="highlight-text">{data[col.field].value}</h6>
                      <h6 className="small-text">{data[col.field].value2}</h6>
                    </div>
                  </div>
                </td>
              );
            case 'select_option':
              return (
                <td key={index}>
                  <Select
                    options={AwardStatus}
                    styles={customStyle}
                    value={clientData?.award_status || AwardStatus?.find((status) => status?.value === data[col.field]?.value)}
                    placeholder="---"
                    onChange={async (val) => {
                      await updateAward(data?.checkbox?.value, { status: val?.value });
                      setClientData((preVal) => ({
                        ...preVal,
                        award_status: val,
                      }));
                    }}
                    theme={(theme) => ({
                      ...theme,
                      colors: {
                        ...theme.colors,
                        primary25: '#5757fe',
                        primary: '#5757fe',
                      },
                    })}
                    getOptionLabel={(e) => (
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span
                          style={{
                            height: '12px',
                            width: '12px',
                            backgroundColor: e.color,
                            borderRadius: '50%',
                            display: 'inline-block',
                            marginRight: '10px',
                            marginLeft: '10px'
                          }}
                        />
                        {e.label}
                      </div>
                    )}
                    getOptionValue={(e) => e.value}
                  />
                </td>
              );

            case 'ticket_select_option':
              return (
                <td key={index}>
                  <Select
                    options={TicketStatus}
                    styles={customStyle}
                    value={clientData?.ticket_status || TicketStatus?.find((status) => status?.value === data[col.field]?.value)}
                    placeholder="---"
                    onChange={async (val) => {
                      await updateTicket(data?.checkbox?.value, { status: val?.value });
                      setClientData((preVal) => ({
                        ...preVal,
                        ticket_status: val,
                      }));
                    }}
                    theme={(theme) => ({
                      ...theme,
                      colors: {
                        ...theme.colors,
                        primary25: '#5757fe',
                        primary: '#5757fe',
                      },
                    })}
                    getOptionLabel={(e) => (
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span
                          style={{
                            height: '12px',
                            width: '12px',
                            backgroundColor: e.color,
                            borderRadius: '50%',
                            display: 'inline-block',
                            marginRight: '10px',
                            marginLeft: '10px'
                          }}
                        />
                        {e.label}
                      </div>
                    )}
                    getOptionValue={(e) => e.value}
                  />
                </td>
              );


            case 'status_type':
              return (
                <td className="table-data-td" key={index}>
                  <div className="statusType">
                    <div
                      className={`statusType-background`}
                      style={{
                        backgroundColor:
                          data[col.field]?.value === 'In Progress' ? '#41A7DC41' :
                            data[col.field]?.value === 'Not Started' ? '#D3D3D3' :
                              data[col.field]?.value === 'On Hold' ? '#FFF3CD' :
                                data[col.field]?.value === 'Cancelled' ? '#F8D7DA' :
                                  data[col.field]?.value === 'Finished' ? '#D4EDDA' : 'transparent',
                        color:
                          data[col.field]?.value === 'In Progress' ? '#41A7DC' :
                            data[col.field]?.value === 'Not Started' ? '#808080' :
                              data[col.field]?.value === 'On Hold' ? '#F5C308' :
                                data[col.field]?.value === 'Cancelled' ? 'red' :
                                  data[col.field]?.value === 'Finished' ? 'green' : '#000000'
                      }}
                    >
                      <h6 className={`statusType-text`}>{data[col.field]?.value}</h6>
                    </div>
                  </div>
                </td>
              );

            case 'status_option':
              const userHasPermission = data?.user?.role?.name == "hr_senior" ? true : data?.allData?.taskUserMap?.some(item => item?.user_id == user?.id);
              const currentStatus = data[col.field]?.value;
              const selectedStatus = TaskStatus?.find((status) => status?.value === currentStatus);

              return (
                <td key={data?.checkbox?.value} style={{ width: "200px" }}>
                  {userHasPermission ? (
                    <Select
                      options={TaskStatus?.filter(item => item?.taskStatus?.find(status => status?.project_id == data?.allData?.project?.id))?.sort((a, b) => {
                        const aOrder = a?.taskStatus?.find(s => s.project_id == data?.id)?.sort_order || 0;
                        const bOrder = b?.taskStatus?.find(s => s.project_id == data?.id)?.sort_order || 0;
                        return aOrder - bOrder;
                      })}
                      styles={{
                        ...customStyle,
                        menu: (provided) => ({
                          ...provided,
                          zIndex: 2,
                          width: '100%',
                        }),
                        control: (provided) => ({
                          ...provided,
                          boxShadow: 'none',
                          border: '1px solid #ced4da',
                        }),
                        placeholder: (provided) => ({
                          ...provided,
                          color: '#6c757d',
                        }),
                      }}
                      value={TaskStatus?.find((status) => status?.value === currentStatus)}
                      placeholder="---"
                      onChange={async (val) => {
                        await updateTask(data?.checkbox?.value, { status: val?.value }, true);
                        // setClientData((preVal) => ({
                        //   ...preVal,
                        //   projectstatus: val
                        // }));
                      }}
                      theme={(theme) => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          primary25: "#5757fe",
                          primary: "#5757fe",
                        },
                      })}
                      isSearchable
                      getOptionLabel={(e) => (
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <span
                            style={{
                              height: '12px',
                              width: '12px',
                              backgroundColor: e.color,
                              borderRadius: '50%',
                              display: 'inline-block',
                              marginRight: '10px',
                              marginLeft: '10px'
                            }}
                          />
                          {e.label}
                        </div>
                      )}
                      getOptionValue={(e) => e.value}
                    />
                  ) : (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <span
                        style={{
                          height: '12px',
                          width: '12px',
                          backgroundColor: selectedStatus?.color || '#ccc',
                          borderRadius: '50%',
                          display: 'inline-block',
                          marginRight: '10px',
                          marginLeft: '10px'
                        }}
                      />
                      {selectedStatus?.label || '---'}
                    </div>
                  )}
                </td>
              );

            case 'address':
              return (
                <td className="table-data-td address-td" key={index}>
                  <div className="address">
                    <p>
                      {data[col.field].value}, {data[col.field].value2}, {data[col.field].state},{' '}
                      {data[col.field].country} - {data[col.field].postalcode}
                    </p>
                  </div>
                </td>
              );

            case 'progressbar':
              return (
                <td className="table-data-td" key={index}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <ProgressBar
                      now={data[col.field].value}
                      label={false}
                      style={{ height: '10px', width: '100%' }}
                    />
                    <span style={{ marginLeft: '10px' }}>{`${data[col.field].value}%`}</span>
                  </div>
                </td>
              );

            case 'clockinout':
              return <td className="table-data-td" key={index}>
                <div className='clockinoutcomp'>
                  <h6>{data[col.field].value}</h6>
                  <h6>{data[col.field].value2}</h6>
                </div>
              </td>

            case 'startstop':
              return (
                <td className="table-data-td" key={index}>
                  <div className="taskstartstop-icons">
                    {(data[col.field]?.value && !data[col.field]?.value2) ? (
                      <div className="icon-container">
                        <div className="pause-icon">
                          <BsPauseCircleFill onClick={() => updateTimer("pauseClicked")} />
                        </div>
                        <div className="stop-icon">
                          <BsStopCircleFill onClick={() => updateTimer("stopClicked")} />
                        </div>
                      </div>
                    ) : (
                      <div className="icon-container">
                        <div className="play-icon">
                          <FaCirclePlay onClick={() => updateTimer("playClicked")} />
                        </div>
                      </div>
                    )}
                  </div>
                </td>
              );

            case 'assignto':
              const assignedToNames = data[col.field].value.split(',').map(name => name.trim());
              const displayedNames = assignedToNames.slice(0, 2);
              const moreNames = assignedToNames.length > 2;

              return (

                <td className="table-data-td" key={index}>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <h6 className="text" style={{ margin: '0' }}>{displayedNames[0]}</h6>

                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <h6 className="text" style={{ margin: '0' }}>{displayedNames[1]}</h6>
                      {moreNames && (
                        <span className="task-tooltip" style={{ marginLeft: '5px' }}>
                          <HiPlus className='task-plus-icon' />
                          <div className="tooltip-content">
                            <div className="tooltip-arrow"></div>
                            <ul style={{ listStyleType: 'none', padding: 0, margin: 0 }}>
                              {assignedToNames.map((name, idx) => (
                                <li key={idx}>{name}</li>
                              ))}
                            </ul>
                          </div>
                        </span>
                      )}
                    </div>
                  </div>

                  <div>
                    <h6 style={{ color: "rgb(119, 126, 137)", marginTop: "10px" }}>
                      {data[col.field].title || ""}
                    </h6>
                  </div>
                </td>
              );

            case 'empassignto':
              const empassignedToNames = Array.isArray(data[col.field].value) ? data[col.field].value : [];
              // .split(',').map(name => name.trim());
              const empdisplayedNames = empassignedToNames.slice(0, 2);
              const empmoreNames = empassignedToNames.length > 2;

              return (
                <td className="table-data-td" key={index}>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <h6 className="emptext" style={{ margin: '0' }}>{empdisplayedNames[0]}</h6>

                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <h6 className="text" style={{ margin: '0' }}>{empdisplayedNames[1]}</h6>
                      {empmoreNames && (
                        <span className="task-tooltip" style={{ marginLeft: '5px' }}>
                          <HiPlus className='task-plus-icon' />
                          <div className="tooltip-content">
                            <div className="tooltip-arrow"></div>
                            <ul style={{ listStyleType: 'none', padding: 0, margin: 0 }}>
                              {empassignedToNames.map((name, idx) => (
                                <li key={idx}>{name}</li>
                              ))}
                            </ul>
                          </div>
                        </span>
                      )}
                    </div>
                  </div>

                  <div>
                    <h6 style={{ color: "rgb(119, 126, 137)", marginTop: "10px" }}>
                      {data[col.field].title || ""}
                    </h6>
                  </div>
                </td>
              );


            case 'tasktimer':
              return (
                <td className="table-data-td" key={index}>
                  <div className='taskwithtimer'>
                    <h6 className="text">{data[col.field].value}</h6>
                    <h6 className='task-timer'><MdOutlineWatchLater className='timer-clock-icon' />{data[col.field].value2}</h6>
                  </div>
                </td>
              );

            case 'emptasktimer':
              return (
                <td className="table-data-td" key={index}>
                  <div className='emptaskwithtimer'>
                    <h6 className='emptask-timer'>{data[col.field].value}</h6>
                  </div>
                </td>
              );

            case 'taskstartstop':
              return (
                <td className="table-data-td" key={index}>
                  <div className="taskstartstop-icons">
                    {(data[col.field]?.value === "running" || data[col.field]?.value === "resumed") && (
                      <div className="icon-container">
                        <div className="pause-icon">
                          <BsPauseCircleFill onClick={() => updateTimer("pauseClicked")} />
                        </div>
                        <div className="stop-icon">
                          <BsStopCircleFill onClick={() => updateTimer("stopClicked")} />
                        </div>
                      </div>
                    )}

                    {data[col.field]?.value === "paused" && (
                      <div className="icon-container">
                        <div className="play-icon">
                          <FaCirclePlay onClick={() => updateTimer("resumeClicked")} />
                        </div>
                        <div className="stop-icon">
                          <BsStopCircleFill onClick={() => updateTimer("stopClicked")} />
                        </div>
                      </div>
                    )}

                    {(data[col.field]?.value === "stopped" || !data[col.field]?.value) && (
                      <div className="icon-container">
                        <div className="play-icon">
                          <FaCirclePlay onClick={() => updateTimer("playClicked")} />
                        </div>
                      </div>
                    )}
                  </div>
                </td>
              );

            case 'documents':
              return (
                <td className="table-data-td" key={index}>
                  <div className="file-cell">
                    <div className="file-icon">
                      {data[col.field]?.value?.toLowerCase().endsWith('.pdf') ?
                        (
                          <img src={Pdf} alt="PDF Icon" className="file-icon-img" />
                        ) :

                        data[col.field]?.value?.toLowerCase().endsWith('.jpg') ?
                          (
                            <img src={Jpg} alt="JPG Icon" className="file-icon-img" />
                          ) :

                          data[col.field]?.value?.toLowerCase().endsWith('.png') ? (
                            <img src={Png} alt="PNG Icon" className="file-icon-img" />
                          ) : (
                            <img src={Image} alt="PNG Icon" className="file-icon-img" />
                          )}
                    </div>
                    <div className="file-name">
                      <h6 className="highlight-text">{data[col.field]?.value}</h6>
                    </div>
                  </div>
                </td>
              );

            case 'salaryamount':
              return (
                <td className="table-data-td" key={index}>
                  <div className="file-cell">
                    <div className="file-name">
                      {visibility[col.field] ? '₹ *****' : data[col.field]?.value}
                    </div>
                    <div className="file-icon" onClick={() => amountVisibility(col.field)}>
                      <img
                        src={visibility[col.field] ? OpenEye : CloseEye}
                        alt={visibility[col.field] ? "OpenEye Icon" : "CloseEye Icon"}
                        className="eye-icon"
                      />
                    </div>
                  </div>
                </td>
              );

            case 'variationamount':
              return (
                <td className="table-data-td" key={index}>
                  <div className="file-cell">
                    <div>
                      <img src={RightUpArrow} className='right-up-arrow' alt='Arrow Not Found' />
                    </div>
                    <div className="file-name">
                      {visibility[col.field] ? '₹ *****' : data[col.field]?.value}
                    </div>
                    <div className="file-icon" onClick={() => amountVisibility(col.field)}>
                      <img
                        src={visibility[col.field] ? OpenEye : CloseEye}
                        alt={visibility[col.field] ? "OpenEye Icon" : "CloseEye Icon"}
                        className="eye-icon"
                      />
                    </div>
                  </div>
                </td>
              );

            case 'waterJugCounter':
              const jugItem = data.allData;
              const updatedValue = Number(jugItem?.no_of_jug) || 1;

              return (
                <td className="table-data-td" key={index}>
                  <div className="file-cell">

                    <div className="jug-counter">
                      <button
                        className="icon-btn"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDecrement(jugItem);
                        }}
                        disabled={updatedValue <= 1}
                      >
                        <CiCircleMinus size={20} />
                      </button>

                      <span className="jug-counter-num">{updatedValue}</span>

                      <button
                        className="icon-btn"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleIncrement(jugItem);
                        }}
                      >
                        <CiCirclePlus size={20} />
                      </button>
                    </div>
                  </div>
                </td>
              );

            default:
              return <td className="table-data-td" key={index}></td>;
          }
        } else {
          return <td className="table-data-td" key={index}></td>;
        }
      })}
    </tr >
  );
};

export default TableRow;
